import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import { I18n } from './../i18n';

class SearchBar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      search: '',
      type: 'all',
      beginDate: null,
      endDate: null
    };
    this.options = [
      { value: 'all', label: 'All' },
      { value: 'major', label: 'Major' },
      { value: 'minor', label: 'Minor' },
      { value: 'patch', label: 'Patch' }
    ];
    this.handleTextSearchChange = this.handleTextSearchChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  filterLogs () {
    let filteredLogs = this.props.changelogs;

    // Filter by type
    if (this.state.type !== 'all') {
      filteredLogs = filteredLogs.filter(log => JSON.stringify(log.update_type) === JSON.stringify(this.state.type));
    }

    // Filter by text
    if (this.state.search) {
      filteredLogs = filteredLogs.filter(log => JSON.stringify(log).toLowerCase().includes(this.state.search.toLowerCase()));
    }

    // Filter by date
    if (this.state.beginDate) {
      filteredLogs = filteredLogs.filter(log => new Date(log.created_at).setHours(0, 0, 0, 0) >= new Date(this.state.beginDate).setHours(0, 0, 0, 0));
    }
    if (this.state.endDate) {
      filteredLogs = filteredLogs.filter(log => new Date(log.created_at).setHours(0, 0, 0, 0) <= new Date(this.state.endDate).setHours(0, 0, 0, 0));
    }

    this.props.onFilterChange(filteredLogs);
  }

  handleTypeChange (event) {
    this.setState({
      type: event.value
    }, this.filterLogs);
  }

  handleBeginDateChange (event) {
    this.setState({
      beginDate: event
    }, this.filterLogs);
  }

  handleEndDateChange (event) {
    this.setState({
      endDate: event
    }, this.filterLogs);
  }

  handleTextSearchChange (event) {
    this.setState({
      search: event.target.value
    }, this.filterLogs);
  }

  handleClear () {
    this.setState({
      search: '',
      type: 'all',
      beginDate: null,
      endDate: null
    }, () => this.props.onFilterChange(this.props.changelogs)
    );
  }

  render () {
    return (
      <form>
        <div className="row d-flex align-items-center ml-2">
          <div className="form-group col-3">
            <label />
            <div className="input-group-prepend mt-2">
              <span className="input-group-text">
                <span className="fa fa-search" />
              </span>
              <input
                value={this.state.search}
                placeholder="Search"
                onChange={this.handleTextSearchChange}
                className="p-1"
              />
            </div>
          </div>
          <div className="form-group col-2">
            <label>{I18n.t('changelogs.type')}</label>
            <ReactSelect
              isSearchable={false}
              value={this.options.filter((option) => option.value === this.state.type)}
              options={this.options}
              onChange={this.handleTypeChange}
              isClearable={false}
            />
          </div>
          <div className="form-group col-2">
            <label>{I18n.t('changelogs.time_range')}</label>
            <Flatpickr
              placeholder="Begin"
              className="custom-select"
              value={this.state.beginDate}
              onChange={this.handleBeginDateChange}
              options={{ dateFormat: 'd-m-y', maxDate: new Date(), locale: I18n.locale }}
            />
          </div>
          <div className="form-group col-2">
            <Flatpickr
              placeholder="End"
              value={this.state.endDate}
              className="custom-select"
              onChange={this.handleEndDateChange}
              options={{ dateFormat: 'd-m-y', maxDate: new Date(), locale: I18n.locale }}
              style={{ marginTop: '1.95em' }}
            />
          </div>
          <div className="row d-flex align-items-center ml-2">
            <button
              type="button"
              className="btn btn-link col-1 mt-3"
              onClick={this.handleClear}
            >
              {I18n.t('action.reset')}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

SearchBar.propTypes = {
  changelogs: PropTypes.array,
  onFilterChange: PropTypes.func
};

export default SearchBar;
